import React, { useEffect, useState, useContext, useMemo } from 'react'
import Select from 'react-select'
import AppointmentService from '../../../../../services/api/appointment.service'
import { store } from "../../../../../context/StateProvider";
import { useGetAppointmentStatusCodes } from "../../../../../services/cache/CacheService";
import APIResponse from '../../../../templates/components/APIResponse';

const AppointmentStatus = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const statusList = useGetAppointmentStatusCodes();
    const [selectedStatus, setSelectedStatus] = useState()
    const [applyToRelated, setApplyToRelated] = useState(!(props.appointment?.parentGroupId) ?? true);
    const [apiResponse, setApiResponse] = useState()
    const selectStatus = (status) => {
        setSelectedStatus(status)
    }
    const onSuccess = (message) => {
        props.onStatusUpdated(selectedStatus,applyToRelated)
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const updateStatus = () => {
        setIsLoader(true)
        const payload = {
            practiceAppointmentStatusCodeId: selectedStatus.practiceAppointmentStatusCodeId
        };

        if (applyToRelated) {
            payload.applyStatusToChildren = true;
        }
        AppointmentService.updateAppintmentStatus(payload, props.appointmentId)
        .then(
            (response) => {
                setApiResponse(response);
            })
        .catch(
            (error) => {
                setApiResponse(error);
            }
        ).finally(() => {
            setIsLoader(false)
        });
    }

    useEffect(() => {
        if (statusList) {
            statusList.map((status,i) => {
                if (status.practiceAppointmentStatusCodeId == props.appointment.practiceAppointmentStatusCodeId) selectStatus(status);
            });
        }
    }, [statusList])

    return (
        <>
            {isLoader && (
            <div className="ui active dimmer">
                <div className="ui indeterminate text loader">Loading...</div>
            </div>
            )}

            {statusList && (
                <div className='row d-flex align-items-end justify-content-between'>
                    <div className='col-12'>
                        <div style={{display: "flex", height: '70px', alignItems: 'stretch', justifyContent:'space-between'}}>
                            {
                                statusList.map((status,i) => (
                                    <div key={i}>
                                        {props.appointment.parentGroupId && status.isCheckout ? null : 
                                        <i  style={{fontSize: selectedStatus && status.practiceAppointmentStatusCodeId == selectedStatus.practiceAppointmentStatusCodeId ? 'xxx-large' : 'xx-large', alignSelf:"center"}} 
                                            onClick={(e) => { 
                                                e.preventDefault();
                                                selectStatus(status); 
                                            }} 
                                            className={`ui icon ${status.icon} btn p-0 mb-2 apptStatusIcon`}
                                            title={status.appointmentStatusLabel}
                                        /> 
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className='col-auto'>
                        {!props.appointment.parentGroupId && (
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="applyToRelated"
                                    checked={applyToRelated}
                                    onChange={(e) => setApplyToRelated(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="applyToRelated">
                                    Apply to related appointments (if applicable)
                                </label>
                            </div>
                        )}
                    </div>
                    
                    <div className="col-auto">
                        {props.extraButton && props.extraButton}
                        <button disabled={!selectedStatus || props.appointment.practiceAppointmentStatusCodeId==selectedStatus.practiceAppointmentStatusCodeId} className='btn btn-primary ms-3 col-auto' onClick={e => { e.preventDefault(); updateStatus() }}>{selectedStatus ? selectedStatus.appointmentStatusLabel : "Status Not Selected"}</button>
                        <button className='btn btn-secondary ms-3 col-auto' onClick={e => { e.preventDefault(); props.onClose() }}>{'Cancel'}</button>
                    </div>
                </div>
            )}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}
export default AppointmentStatus